module.exports = __webpack_public_path__ + "static/assets/b84d093ed85484282118fdb25ce3e3f9.png";